import {delay, Vector2} from "p3";
import common from "../common";

export default class Swiper {
    /**
     * @param {PIXI.Texture} texture
     * @param {Number} range
     */
    constructor(stageBounds) {
        this._stageBounds = stageBounds;
        this._dragging = false;
        this._mouseUpSignal = null;
        this._mouseDownSignal = null;
        this._mouseMoveSignal = null;
        this._startPos = new Vector2(0, 0);
        this._drag = new Vector2(0, 0);
        this._slideSpeed = new Vector2(0, 0);
        this._slideDistance = new Vector2(0, 0);
        this.enabled = true;
        this.init();
    }

    init(){
        this._mouseUpSignal = P3.input.signals.mouseUp.add(this._onMouseUp, this);
        this._mouseDownSignal = P3.input.signals.mouseDown.add(this._onMouseDown, this);
        this._mouseMoveSignal = P3.input.signals.mouseMove.add(this._onMouseMove, this);
        /*
        const overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        overlay.tint = 0x000000;
        overlay.alpha = 0.5;
        overlay.x = this._stageBounds.x;
        overlay.y = this._stageBounds.y;
        overlay.width = this._stageBounds.width;
        overlay.height = this._stageBounds.height;
        P3.scene.top.addChild(overlay);*/
        
    }

    destroy(){
        this._mouseMoveSignal.detach();
        this._mouseUpSignal.detach();
        this._mouseDownSignal.detach();
    }

    update(){
        if(!this._dragging) {
            this._slideSpeed.scaleBy(0.95);
            this._slideDistance.incrementBy(this._slideSpeed);
        }
    }

    reset(){
        this._drag.set(0, 0);
        this._startPos.set(0, 0);
        this._slideDistance.set(0, 0);
    }

    cancel(){
        this.reset();
        this._slideSpeed.set(0, 0);
    }

    _onMouseDown(e){
        if (!this.enabled) {
            return;
        }

        const pos = e.data.getLocalPosition(P3.scene.top);
        if (pos.x > this._stageBounds.x && 
            pos.y > this._stageBounds.y &&
            pos.x < this._stageBounds.x + this._stageBounds.width &&
            pos.y < this._stageBounds.y + this._stageBounds.height) {

            this._startPos.set(pos.x, pos.y);
            this._drag.set(pos.x, pos.y);
            this._slideDistance.set(0, 0);
            this._slideSpeed.set(0, 0);
            this._dragging = true;
        }
    }

    _onMouseUp(e) {
        if (!this.enabled) {
            return;
        }
        this._dragging = false;
    }

    _onMouseMove(e) {
        if (!this.enabled) {
            return;
        }
        if(!this._dragging) {
            return;
        }
        const pos = e.data.getLocalPosition(P3.scene.top);

        this._slideSpeed.set(pos.x - this._drag.x, pos.y - this._drag.y);
        this._slideSpeed.scaleBy(0.5);
        this._drag.set(pos.x, pos.y);
    }

    get dragging() {
        return this._dragging;
    }

    get x() {
        const offset = this._drag.x - this._startPos.x;
        if (this._dragging) {
            return offset;
        } else {
            return offset + this._slideDistance.x;
        }
    }

    get y() {
        const offset = this._drag.y - this._startPos.y;
        if (this._dragging) {
            return offset;
        } else {
            return offset + this._slideDistance.y;
        }
    }

}

